class WishlistRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const wishlistItems = this.closest('wishlist-items') || this.closest('wishlist-drawer-items');
      wishlistItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('wishlist-remove-button', WishlistRemoveButton);

class WishlistItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-wishlist-line-item-status') || document.getElementById('WishlistDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  wishlistUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.wishlistUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.wishlistUpdate, (event) => {
      if (event.source === 'wishlist-items') {
        return;
      }
      this.onWishlistUpdate();
    });
  }

  disconnectedCallback() {
    if (this.wishlistUpdateUnsubscriber) {
      this.wishlistUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onWishlistUpdate() {
    if (this.tagName === 'WISHLIST-DRAWER-ITEMS') {
      fetch(`${routes.wishlist_url}?section_id=wishlist-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['wishlist-drawer-items', '.wishlist-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.wishlist_url}?section_id=main-wishlist-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('wishlist-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-wishlist-items',
        section: document.getElementById('main-wishlist-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'wishlist-icon-bubble',
        section: 'wishlist-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'wishlist-live-region-text',
        section: 'wishlist-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-wishlist-footer',
        section: document.getElementById('main-wishlist-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.wishlist_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.wishlist-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const wishlistDrawerWrapper = document.querySelector('wishlist-drawer');
        const wishlistFooter = document.getElementById('main-wishlist-footer');

        if (wishlistFooter) wishlistFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (wishlistDrawerWrapper) wishlistDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.wishlistStrings.error;
          } else {
            message = window.wishlistStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`WishlistItem-${line}`) || document.getElementById(`WishlistDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          wishlistDrawerWrapper
            ? trapFocus(wishlistDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && wishlistDrawerWrapper) {
          trapFocus(wishlistDrawerWrapper.querySelector('.drawer__inner-empty'), wishlistDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.wishlist-item') && wishlistDrawerWrapper) {
          trapFocus(wishlistDrawerWrapper, document.querySelector('.wishlist-item__name'));
        }

        publish(PUB_SUB_EVENTS.wishlistUpdate, { source: 'wishlist-items', wishlistData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('wishlist-errors') || document.getElementById('WishlistDrawer-WishlistErrors');
        errors.textContent = window.wishlistStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`WishlistDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.wishlist-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const wishlistStatus =
      document.getElementById('wishlist-live-region-text') || document.getElementById('WishlistDrawer-LiveRegionText');
    wishlistStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      wishlistStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainWishlistItems = document.getElementById('main-wishlist-items') || document.getElementById('WishlistDrawer-WishlistItems');
    mainWishlistItems.classList.add('wishlist__items--disabled');

    const wishlistItemElements = this.querySelectorAll(`#WishlistItem-${line} .loading__spinner`);
    const wishlistDrawerItemElements = this.querySelectorAll(`#WishlistDrawer-Item-${line} .loading__spinner`);

    [...wishlistItemElements, ...wishlistDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainWishlistItems = document.getElementById('main-wishlist-items') || document.getElementById('WishlistDrawer-WishlistItems');
    mainWishlistItems.classList.remove('wishlist__items--disabled');

    const wishlistItemElements = this.querySelectorAll(`#WishlistItem-${line} .loading__spinner`);
    const wishlistDrawerItemElements = this.querySelectorAll(`#WishlistDrawer-Item-${line} .loading__spinner`);

    wishlistItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    wishlistDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('wishlist-items', WishlistItems);

if (!customElements.get('wishlist-note')) {
  customElements.define(
    'wishlist-note',
    class WishlistNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.wishlist_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
